export const ASSET_EXPLORE_UPLOAD_GET_DATA = 'ASSET_EXPLORE_UPLOAD_GET_DATA'
export const ASSET_EXPLORE_UPLOAD_GET_DATA_SUCCESS = 'ASSET_EXPLORE_UPLOAD_GET_DATA_SUCCESS'
export const ASSET_EXPLORE_UPLOAD_GET_DATA_FAILURE = 'ASSET_EXPLORE_UPLOAD_GET_DATA_FAILURE'
export const CLEAN_DATA_BACK = 'CLEAN_DATA_BACK'
